export default __webpack_public_path__ + "static/media/spinner-2.a1a99674.gif";